import type { ReportUsage } from '@ms/yammer-telemetry';
import { createContext, useContext } from 'react';

export const emptyReportUsage = (): void => void 0;

export interface TelemetryContext {
  readonly reportUsage: ReportUsage;
}

export const defaultOptions: TelemetryContext = {
  reportUsage: emptyReportUsage,
};

export const TelemetryContext = createContext(defaultOptions);

export type UseTelemetryContext = () => TelemetryContext;
export const useTelemetryContext: UseTelemetryContext = () => useContext(TelemetryContext);
